import { render, staticRenderFns } from "./Client.vue?vue&type=template&id=4f51789a&"
import script from "./Client.vue?vue&type=script&lang=js&"
export * from "./Client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f51789a')) {
      api.createRecord('4f51789a', component.options)
    } else {
      api.reload('4f51789a', component.options)
    }
    module.hot.accept("./Client.vue?vue&type=template&id=4f51789a&", function () {
      api.rerender('4f51789a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Quotations/Tabs/Client.vue"
export default component.exports